import { ROUTE } from '../../routes';

const SUNNY_CHAT_RECOMMENDED_QUESTIONS: { match: ROUTE | RegExp; key: string }[] = [
  { match: ROUTE.PROJECT_DETAIL, key: 'sunnyChat.recommendedQuestions.projectDetail' },
  { match: ROUTE.HOME_PROJECT_DETAIL, key: 'sunnyChat.recommendedQuestions.projectDetail' },
  { match: ROUTE.UTILITY_BILL_UPLOAD, key: 'sunnyChat.recommendedQuestions.utilityBillUpload' },
  { match: ROUTE.PAYMENT_SETUP, key: 'sunnyChat.recommendedQuestions.paymentSetup' },
  { match: ROUTE.CREDIT_CHECK, key: 'sunnyChat.recommendedQuestions.creditCheck' },
  { match: ROUTE.SUPPORT, key: 'sunnyChat.recommendedQuestions.support' },
  { match: /^\/service(\/|$)/, key: 'sunnyChat.recommendedQuestions.service' },
];

export function getSunnyChatRecommendedQuestionsKey(route: string | undefined): string | undefined {
  if (!route) return undefined;
  return SUNNY_CHAT_RECOMMENDED_QUESTIONS.find(({ match }) =>
    typeof match === 'string' ? match === route : match.test(route),
  )?.key;
}
